import React, { useEffect, useRef, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas'
import { store } from "react-notifications-component";
import Button from '../button/button_v2';
import PlanilhaDropzone, { formatFileSize } from '../planilha-dropzone';
import { InputContainer, Label, Linha, Container, ContainerDivider, Divider } from './styles';
import { isTotvs } from '../../services/globalFunctions';
import { theme } from '../../styles/theme';
import { TaglineP } from '../../styles/stylesTypography';

// A assinatura entra como imagem; o dropzone recusa o resto antes de chegar
// aqui, mas a checagem de tipo continua no onChange por garantia.
const ASSINATURA_ACCEPT = {
    'image/png': ['.png'],
    'image/jpeg': ['.jpg', '.jpeg'],
};

const InputSign = ({ ...props }) => {

    const signRef = useRef();
    const [sign, setSign] = useState('');
    const [tipoSign, setTipoSign] = useState(0);
    const [namesfiles, setNamesfiles] = useState([]);
    // Imagem escolhida no dropzone, ainda nao aplicada: so vira assinatura
    // quando o usuario confirma no "Salvar".
    const [imagemSelecionada, setImagemSelecionada] = useState(null);

    const saveSign = () => {
        let sign = signRef.current.toDataURL();
        setSign(sign);
        props.update(sign);
    }

    const clearSign = () => {
        signRef.current.clear()
        setSign('');
    }

    const editSign = () => {
        setSign('');
        deleteFile();
        props.update('');
    }

    const notificaErro = (mensagem) => {
        store.addNotification({
            title: "Erro!",
            message: mensagem,
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
                duration: 4000,
                onScreen: true
            }
        });
    };

    // Recebe o File escolhido no dropzone (antes vinha o evento do <input>).
    const onChangeCertificate = (arquivo) => {

        if (arquivo) {
            if (
                arquivo.type == "image/png" ||
                arquivo.type == "image/jpeg"
            ) {
                let reader = new FileReader();
                reader.readAsDataURL(arquivo);

                reader.onload = (e) => {
                    setSign(e.target.result);
                    props.update(e.target.result);
                }
                setNamesfiles(arquivo.name);

            } else {
                notificaErro(`O arquivo selecionado não possui a extensão correta`);
            }
        } else {
            notificaErro(`Selecione um arquivo para enviar.`);
        }

    };
    const deleteFile = () => {
        setNamesfiles([]);
        setImagemSelecionada(null);
    };

    const salvarImagemSelecionada = () => {
        if (!imagemSelecionada) return;

        onChangeCertificate(imagemSelecionada);
        setImagemSelecionada(null);
    };


    useEffect(() => {
        if (props.sign && props.sign !== '') {
            setSign(props.sign);
        }
    }, [])

    useEffect(() => {
        if (tipoSign != 0) {
            deleteFile();
            setSign('');
        }
    }, [tipoSign])


    return (

        <Container>
            {sign === '' ? (
                <>
                    {tipoSign === 0 ? (<>
                        <div
                            className="button-finish"
                            style={{
                                width: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                // gap (em vez de margin em cada filho - botão, texto, div) separa
                                // tudo com 16px de uma vez só.
                                gap: '16px',
                            }}
                        >
                            <Button
                                // "auto" (era 45%) - com largura percentual o botão aplica
                                // white-space:normal (ver ../button/styles.js) e o texto
                                // quebrava em duas linhas; "auto" usa nowrap.
                                width='auto'
                                height='45px'
                                value='Desenhar assinatura'
                                outline={false}
                                disabled={false}
                                onClick={() => setTipoSign(1)}
                                loading={false}
                            />

                            <ContainerDivider>
                                <Divider />
                                <TaglineP color={theme.colors.gray.Cinza_2}>ou</TaglineP>
                                <Divider />
                            </ContainerDivider>

                            <PlanilhaDropzone
                                descricao="A imagem selecionada será utilizada como assinatura para as receitas emitidas com o responsável técnico."
                                chamada="Arraste a imagem da assinatura aqui"
                                legenda="PNG ou JPG, até 3 MB"
                                accept={ASSINATURA_ACCEPT}
                                arquivo={
                                    imagemSelecionada
                                        ? {
                                            nome: imagemSelecionada.name,
                                            tamanho: formatFileSize(imagemSelecionada.size),
                                            extensao: imagemSelecionada.name.split('.').pop() || '',
                                        }
                                        : null
                                }
                                onSelect={(arquivo) => setImagemSelecionada(arquivo)}
                                onRemove={() => setImagemSelecionada(null)}
                                onReject={(motivo) => notificaErro(motivo)}
                            />

                            <div style={{ width: '100%' }}>
                                <Button
                                    width='100%'
                                    height='45px'
                                    value='SALVAR'
                                    outline={false}
                                    disabled={!imagemSelecionada}
                                    onClick={() => salvarImagemSelecionada()}
                                    loading={false}
                                />
                            </div>

                        </div>
                    </>) : (<>
                        {tipoSign === 1 ? (<>
                            <InputContainer>
                                <SignatureCanvas
                                    ref={signRef}
                                    penColor='black'
                                    canvasProps={{
                                        width: 400,
                                        height: 200,
                                        className: 'sigCanvas'
                                    }}
                                />
                                <Linha />

                            </InputContainer>

                            <div className="button-finish" style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginTop: '0px' }}>
                                <Button
                                    // "auto" (eram 40%) - com largura percentual os botões aplicam
                                    // white-space:normal (ver ../button/styles.js) e o texto
                                    // quebrava em duas linhas; "auto" usa nowrap.
                                    width='auto'
                                    height='40px'
                                    value='LIMPAR'
                                    outline
                                    color={theme.colors.gray.Cinza_2}
                                    disabled={false}
                                    onClick={() => clearSign()}
                                    loading={false}
                                />
                                <Button
                                    width='auto'
                                    height='40px'
                                    value='SALVAR ASSINATURA'
                                    outline={false}
                                    onClick={() => saveSign()}
                                    loading={false}
                                />
                            </div>

                        </>) : (<>


                        </>)}
                    </>)}


                </>
            ) : (
                <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    <InputContainer marginBottom='0px'>
                        <Label>Prévia da assinatura eletrônica</Label>
                        <img src={sign} style={{ border: '0px solid #000', borderRadius: '25px' }} alt='assinatura' width='400px' height='200px' />
                        <Linha />
                    </InputContainer>

                    <label className="legenda" style={{
                        textAlign: 'center'
                    }}>A assinatura será exibida desta forma na receita</label>

                    <div className="button-finish" style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center', gap: '16px' }}>
                        {props.onRemover ? (
                            <Button
                                width='auto'
                                height='40px'
                                value='REMOVER ASSINATURA'
                                outline
                                red
                                disabled={!!props.removendo}
                                loading={!!props.removendo}
                                onClick={() => props.onRemover()}
                            />
                        ) : null}

                        <Button
                            width={props.onRemover ? 'auto' : '40%'}
                            height='40px'
                            value='EDITAR ASSINATURA'
                            // Sólido quando ao lado do "REMOVER ASSINATURA" (ver onRemover acima) -
                            // dois botões outline lado a lado ficavam parecidos demais, sem destaque
                            // pra ação principal. Sem onRemover (demais usos deste componente - ver
                            // prescriptionsteps/step3/form.js, pages/agronomos/addV2.js) continua outline.
                            outline={!props.onRemover}
                            disabled={false}
                            onClick={() => editSign()}
                            loading={false}
                        />
                    </div>
                </div>
            )}
        </Container>

    )
}

export default InputSign;
